<template>
  <div>
    <el-table
      v-if="payments.length"
      :data="payments"
      border
      style="width: 100%"
      row-key="payment_id"
    >
      <el-table-column
        prop="invoice.invoice_number"
        label="Invoice Number"
        width="150"
      />
      <el-table-column
        prop="date"
        label="Date"
        width="120"
        :formatter="format_date"
      />
      <el-table-column
        prop="amount"
        label="Amount"
        width="120"
      />
      <el-table-column
        prop="status"
        label="Status"
        width="100"
      />
    </el-table>

    <div v-else>
      <p>No payments to display.</p>
    </div>
  </div>
</template>

<script>
import { xero_payments } from '../../api/xero';

export default {
  name: 'XeroPayments',
  props: {
    contact: { type: Object, required: true }
  },
  data() {
    return {
      payments: [],
      loading: false
    };
  },
  mounted() {
    this.fetch_payments();
  },
  methods: {
    async fetch_payments() {
      if (!this.contact) return;
      this.loading = true;
      try {
        const response = await xero_payments(this, {contact_id: this.contact.contact_id});
        this.payments = response.data.payments || [];
      } catch (err) {
        console.error('Failed to fetch Xero payments', err);
      } finally {
        this.loading = false;
      }
    },
    format_date(row, column, cellValue) {
      if (typeof cellValue === 'string') {
        const match = /\/Date\((\d+)([+-]\d+)?\)\//.exec(cellValue);
        if (match) {
          const ts = parseInt(match[1], 10);
          return new Date(ts).toLocaleString();
        }
      }
      return cellValue || '';
    }
  }
};
</script>
